"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFavoriteBlog = exports.fetchUserSettings = void 0;

var _ActionTypes = _interopRequireDefault(require("ComposeUI/redux/ActionTypes"));

var _utils = require("ComposeUI/lib/utils");

var _SettingsManager = _interopRequireDefault(require("ComposeUI/data/SettingsManager"));

var settingsManager = new _SettingsManager.default();
/**
 * This file should be reserved for redux actions pertaining the the global app.
 * For all other actions place them in their corresponding action module or create a new module
 */

var fetchUserSettingsPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_USER_SETTINGS_PENDING);
var fetchUserSettingsSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_USER_SETTINGS_SUCCEEDED);
var fetchUserSettingsFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_USER_SETTINGS_FAILED);
var showOnboarding = (0, _utils.createAction)(_ActionTypes.default.SHOW_ONBOARDING_MODAL);

var fetchUserSettings = function fetchUserSettings(id) {
  return function (dispatch) {
    dispatch(fetchUserSettingsPending());
    settingsManager.fetch(id).then(function (resp) {
      return dispatch(fetchUserSettingsSucceeded(resp));
    }, function (resp) {
      if (resp.status === 404) {
        // a 404 usually means the user doesn't have user settings in this scope
        // yet, so just show the onboarding and save a default value. when the
        // user loads the onboarding this will get overridden.
        dispatch(showOnboarding());
        settingsManager.save(id, {
          seenOnboarding: false,
          seenReadOnlyAlert: false
        });
      } else {
        dispatch(fetchUserSettingsFailed(resp));
      }
    });
  };
};

exports.fetchUserSettings = fetchUserSettings;
var fetchFavoriteBlogPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_FAVORITE_BLOG_PENDING);
var fetchFavoriteBlogSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_FAVORITE_BLOG_SUCCEEDED);
var fetchFavoriteBlogFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_FAVORITE_BLOG_FAILED);

var fetchFavoriteBlog = function fetchFavoriteBlog(id) {
  return function (dispatch) {
    dispatch(fetchFavoriteBlogPending());
    settingsManager.fetchFavoriteBlog(id).then(function (resp) {
      return dispatch(fetchFavoriteBlogSucceeded(resp));
    }, function (resp) {
      return dispatch(fetchFavoriteBlogFailed(resp));
    });
  };
};

exports.fetchFavoriteBlog = fetchFavoriteBlog;